import React from 'react';

import PropTypes from 'prop-types';

import './container-query-layout.css';
import { ReturnDetailsGridLayout } from '../return-details-grid-layout';

export const LayoutContainer = ({ addressColumnContent, dateColumnContent, rmaColumnContent }) => {
  return (
    <div className='return-details-grid-container'>
      <ReturnDetailsGridLayout
        addressColumnContent={addressColumnContent}
        className='return-details-grid'
        dateColumnContent={dateColumnContent}
        rmaColumnContent={rmaColumnContent}
      />
    </div>
  );
};

LayoutContainer.propTypes = {
  addressColumnContent: PropTypes.node.isRequired,
  dateColumnContent: PropTypes.node.isRequired,
  rmaColumnContent: PropTypes.node.isRequired,
};
